import React from "react";
import { Box, Typography } from "@mui/material";
import { safeJSONParse } from "../../../utils/helper";
import MarkdownRenderer from "../../MarkdownRenderer";

type TemplateReviewerIntakeAgentProps = {
  parsedContent: any;
};

export default function TemplateReviewerIntakeAgent({
  parsedContent,
}: TemplateReviewerIntakeAgentProps): JSX.Element {
  const finalAnswer = safeJSONParse(parsedContent?.finalAnswer);

  if (!finalAnswer) {
    return <Typography>No data available</Typography>;
  }

  const { question, answer, follow_up } = finalAnswer;

  // Case 1: Only question is present
  const hasOnlyQuestion = question && !answer && !follow_up;

  // Case 2: Answer and follow_up are present (with or without question)
  const hasAnswerAndFollowUp = answer && follow_up;

  if (!hasOnlyQuestion && !hasAnswerAndFollowUp) {
    return <Typography>No data available</Typography>;
  }

  return (
    <Box>
      {hasOnlyQuestion && (
        <Box>
          <MarkdownRenderer content={question} />
        </Box>
      )}

      {hasAnswerAndFollowUp && (
        <Box>
          <MarkdownRenderer content={answer} />
        </Box>
      )}
    </Box>
  );
}
